import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'
import { Button } from '../../group_leader/components/common'
import { makeT, sharedT } from '../../group_leader/helpers/i18n'
import { useDialogFocus } from '../../group_leader/hooks/useDialogFocus'

const t = makeT('group_leader.event_results')

// Escape does nothing while a send is in flight.
const ignoreEscape = () => {}

// A plain confirm: a fixed template to every golfer on a pinned group, by email and text.
const SendScoringLinksModal = ({ onClose, onConfirm, sending }) => {
  const boxRef = useRef(null)

  useDialogFocus(boxRef, sending ? ignoreEscape : onClose, { focusBox: true })

  return createPortal(
    <div className="gl-event-results-modal-overlay" onClick={sending ? undefined : onClose}>
      <div
        className="gl-event-results-modal-box"
        ref={boxRef}
        tabIndex={-1}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={t('send_scoring_links.confirm')}
      >
        <h3 className="gl-event-results-modal-title">{t('send_scoring_links.title')}</h3>
        <div className="gl-event-results-modal-body">{t('send_scoring_links.body')}</div>
        <div className="gl-event-results-modal-actions">
          <Button variant="secondary" size="lg" onClick={onClose} disabled={sending}>
            {sharedT('cancel')}
          </Button>
          <Button variant="primary" size="lg" onClick={onConfirm} disabled={sending}>
            {sending ? t('actions.sending_scoring_links') : t('send_scoring_links.confirm')}
          </Button>
        </div>
      </div>
    </div>,
    document.body,
  )
}

SendScoringLinksModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  sending: PropTypes.bool,
}

export default SendScoringLinksModal
